import type { NavigationSubmenuItem } from './types'

type ProfileSubmenuVisibilityOptions = {
  isStandardOrHigher: boolean
  isWebView: boolean
}

type ProfileSubmenuHrefOptions = {
  myProfileHref: string
  regionalSettingsHref: string
  securityHref: string
  professionalsHref: string
}

export const isB2CProfileSubmenuItemVisible = (
  submenuItem: NavigationSubmenuItem,
  options: ProfileSubmenuVisibilityOptions
): boolean => {
  if (submenuItem.type === 'GetMobileApp') {
    return !options.isWebView
  }

  if (submenuItem.type === 'SwitchToDashboard') {
    return options.isStandardOrHigher
  }

  if (submenuItem.type === 'Professionals') {
    return !options.isStandardOrHigher
  }

  return true
}

export const buildB2CProfileSubmenu = (
  submenu: NavigationSubmenuItem[],
  visibility: ProfileSubmenuVisibilityOptions,
  hrefs: ProfileSubmenuHrefOptions
): NavigationSubmenuItem[] => {
  return submenu
    .filter((submenuItem) => {
      return isB2CProfileSubmenuItemVisible(submenuItem, visibility)
    })
    .map((submenuItem) => {
      if (submenuItem.type === 'MyProfile') {
        return {
          ...submenuItem,
          href: hrefs.myProfileHref,
        }
      }

      if (submenuItem.type === 'RegionalSettings') {
        return {
          ...submenuItem,
          href: hrefs.regionalSettingsHref,
        }
      }

      if (submenuItem.type === 'Security') {
        return {
          ...submenuItem,
          href: hrefs.securityHref,
        }
      }

      if (submenuItem.type === 'Professionals') {
        return {
          ...submenuItem,
          href: hrefs.professionalsHref,
        }
      }

      return submenuItem
    })
}
